import Vue from "vue";
import Router from "vue-router";

import config from "@/configure/index";
import CentralAuth from "../services/auth.service";
import Cookies from "js-cookie";
import axios from "axios";
const admin_path = "/" + config.adminPath;
const title_suffix = "- GoShip";

Vue.use(Router);

let router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      component: () => import("@/components/web/admin/home/Index.vue"),
      name: "t.a.home",
      meta: { title: "Home", layout: "admin-layout", suffix: title_suffix },
    },
    {
      path: admin_path + "/dashboard",
      component: () => import("@/components/web/admin/home/Index.vue"),
      name: "t.a.dashboard",
      meta: { 
          title: "Dashboard", 
          layout: "admin-layout", 
          breadcrumb: [
            { name: 'Dashboard' },
          ],
          suffix: title_suffix 
        },
    },
    {
      path: "/login",
      name: "auth.login",
      meta: {
        layout: "authorization-layout",
        title: "Login",
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/authorization/IndexLogin.vue"),
    },
    {
        path: admin_path + "/sales/billings",
        name: "t.a.sales.billings",
        meta: {
            title: 'Billings',
            icon: '',
            breadcrumb: [
                { name: 'Sales', link: admin_path + "/sales/billings" },
                { name: 'Billings' },
            ],
            suffix: title_suffix
        },
        component: () =>
            import ('@/components/web/admin/sales/billings/Index.vue')
    },
    {
        path: admin_path + "/sales/billings/view/:id",
        name: "t.a.sales.billings.view",
        meta: {
            title: 'Billings',
            icon: '',
            breadcrumb: [
                { name: 'Sales', link: admin_path + "/sales/billings" },
                { name: 'Billings', link: admin_path + "/sales/billings"},
                { name: 'Billings Detail' },
            ],
            suffix: title_suffix
        },
        component: () =>
            import ('@/components/web/admin/sales/billings/ViewDetail.vue')
    },
    {
        path: admin_path + "/service-credit",
        name: "t.a.service-credit.list",
        meta: {
            title: 'Service Credit',
            icon: '',
            breadcrumb: [
                { name: 'Sales', link: admin_path + "/sales/billings" },
                { name: 'Service Credit' },
            ],
            suffix: title_suffix
        },
        component: () =>
            import ('@/components/web/admin/service-credit/List.vue')
    },
    {
        path: admin_path + "/service-credit/:id",
        name: "t.a.service-credit.detail",
        meta: {
            title: 'Service Credit Detail',
            icon: '',
            breadcrumb: [
                { name: 'Sales', link: admin_path + "/sales/billings" },
                { name: 'Service Credit', link: admin_path + "/service-credit" },
                { name: 'Detail' },
            ],
            suffix: title_suffix
        },
        component: () =>
            import ('@/components/web/admin/service-credit/Detail.vue')
    },
    {
      path: admin_path + "/gender",
      name: "t.a.gender",
      meta: {
        title: "Gender",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Gender" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/gender/Index.vue"),
    },
    {
      path: admin_path + "/gender/create",
      name: "t.a.gender_create",
      meta: {
        title: "Gender",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "gender" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/gender/AddGender.vue"),
    },
    {
      path: admin_path + "/gender/:id",
      name: "t.a.gender_show",
      meta: {
        title: "Gender",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "gender" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/gender/ShowGender.vue"),
    },
    {
      path: admin_path + "/gender/:id/edit",
      name: "t.a.gender_edit",
      meta: {
        title: "Gender",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "gender" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/gender/EditGender.vue"),
    },

    {
      path: admin_path + "/industry",
      name: "t.a.industry",
      meta: {
        title: "Industry",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Industry" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/industry/Index.vue"),
    },
    {
      path: admin_path + "/industry/create",
      name: "t.a.industry_create",
      meta: {
        title: "Industry",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "industry" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/industry/AddIndustry.vue"),
    },
    {
      path: admin_path + "/industry/:id",
      name: "t.a.industry_show",
      meta: {
        title: "Industry",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "Industry" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/industry/ShowIndustry.vue"),
    },
    {
      path: admin_path + "/industry/:id/edit",
      name: "t.a.industry_edit",
      meta: {
        title: "Industry",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "Industry" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/industry/EditIndustry.vue"),
    },

    {
      path: admin_path + "/customer-type",
      name: "t.a.customertype",
      meta: {
        title: "Customer Type",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Customer Type" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/customer-type/Index.vue"),
    },
    {
      path: admin_path + "/customer-type/create",
      name: "t.a.customertype_create",
      meta: {
        title: "Customertype",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "customer type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/customer-type/AddCustomerType.vue"),
    },
    {
      path: admin_path + "/customer-type/:id",
      name: "t.a.customertype_show",
      meta: {
        title: "Customer Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "customer type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/customer-type/showCustomerType.vue"),
    },
    {
      path: admin_path + "/customer-type/:id/edit",
      name: "t.a.customertype_edit",
      meta: {
        title: "Customer Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "customer type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/customer-type/EditCustomerType.vue"),
    },

    {
      path: admin_path + "/bank",
      name: "t.a.bank",
      meta: {
        title: "Bank",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Bank" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/bank/create",
      name: "t.a.bank_create",
      meta: {
        title: "bank",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "bank" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/AddBank.vue"),
    },
    {
      path: admin_path + "/bank/:id/edit",
      name: "t.a.bank_edit",
      meta: {
        title: "Bank",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "bank" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/EditBank.vue"),
    },
    {
      path: admin_path + "/bank/:id",
      name: "t.a.bank_show",
      meta: {
        title: "Bank",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "bank" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/ShowBank.vue"),
    },

    {
      path: admin_path + "/country",
      name: "t.a.country",
      meta: {
        title: "Country",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Country" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/country/Index.vue"),
    },
    {
      path: admin_path + "/country/create",
      name: "t.a.country_create",
      meta: {
        title: "Country",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "country" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/country/AddCountry.vue"),
    },
    {
      path: admin_path + "/country/:id",
      name: "t.a.country_show",
      meta: {
        title: "Country",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "country" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/country/ShowCountry.vue"),
    },
    {
      path: admin_path + "/country/:id/edit",
      name: "t.a.country_edit",
      meta: {
        title: "Country",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "country" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/country/EditCountry.vue"),
    },

    {
      path: admin_path + "/shipping-type",
      name: "t.a.shippingtype",
      meta: {
        title: "Shipping Type",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Shipping Type" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/shipping-type/Index.vue"),
    },
    {
      path: admin_path + "/shipping-type/create",
      name: "t.a.shippingtype_create",
      meta: {
        title: "Shipping Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "shipping type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/shipping-type/AddShippingType.vue"),
    },
    {
      path: admin_path + "/shipping-type/:id",
      name: "t.a.shippingtype_show",
      meta: {
        title: "Shipping Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "shipping type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/shipping-type/ShowShippingType.vue"),
    },
    {
      path: admin_path + "/shipping-type/:id/edit",
      name: "t.a.shippingtype_edit",
      meta: {
        title: "Shipping Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "shipping type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/shipping-type/EditShippingType.vue"),
    },

    {
      path: admin_path + "/social-code-type",
      name: "t.a.socialcodetype",
      meta: {
        title: "Social Code Type",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Social Code Type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/social-code-type/Index.vue"),
    },
    {
      path: admin_path + "/social-code-type/create",
      name: "t.a.socialcodetype_create",
      meta: {
        title: "Social Code Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "social code type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/social-code-type/AddSocialCodeType.vue"),
    },
    {
      path: admin_path + "/social-code-type/:id",
      name: "t.a.socialcodetype_show",
      meta: {
        title: "Social Code Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "social code type" }],
        suffix: title_suffix,
      },
      component: () =>
        import(
          "@/components/web/admin/social-code-type/ShowSocialCodeType.vue"
        ),
    },
    {
      path: admin_path + "/social-code-type/:id/edit",
      name: "t.a.socialcodetype_edit",
      meta: {
        title: "Social Code Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "social code type" }],
        suffix: title_suffix,
      },
      component: () =>
        import(
          "@/components/web/admin/social-code-type/EditSocialCodeType.vue"
        ),
    },

    {
      path: admin_path + "/payment-method",
      name: "t.a.paymentmethod",
      meta: {
        title: "Payment Method",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Payment Method" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/payment-method/Index.vue"),
    },
    {
      path: admin_path + "/payment-method/create",
      name: "t.a.paymentmethod_create",
      meta: {
        title: "Payment Method",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "payment method" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/payment-method/AddPaymentMethod.vue"),
    },
    {
      path: admin_path + "/payment-method/:id",
      name: "t.a.paymentmethod_show",
      meta: {
        title: "Payment Method",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "payment method" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/payment-method/ShowPaymentMethod.vue"),
    },
    {
      path: admin_path + "/payment-method/:id/edit",
      name: "t.a.paymentmethod_edit",
      meta: {
        title: "Payment Method",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "payment method" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/payment-method/EditPaymentMethod.vue"),
    },

    {
      path: admin_path + "/vat-method",
      name: "t.a.vatmethod",
      meta: {
        title: "Vat Method",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Vat Method" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/vat-method/Index.vue"),
    },
    {
      path: admin_path + "/vat-method/create",
      name: "t.a.vatmethod_create",
      meta: {
        title: "Vat Method",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "vat method" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/vat-method/AddVatMethod.vue"),
    },
    {
      path: admin_path + "/vat-method/:id",
      name: "t.a.vatmethod_show",
      meta: {
        title: "Vat Method",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "vat method" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/vat-method/ShowVatMethod.vue"),
    },
    {
      path: admin_path + "/vat-method/:id/edit",
      name: "t.a.vatmethod_edit",
      meta: {
        title: "Vat Method",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "vat method" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/vat-method/EditVatMethod.vue"),
    },

    {
      path: admin_path + "/unit",
      name: "t.a.unit",
      meta: {
        title: "Unit",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Unit" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/unit/Index.vue"),
    },
    {
      path: admin_path + "/unit/create",
      name: "t.a.unit_create",
      meta: {
        title: "Unit",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "unit" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/unit/AddUnit.vue"),
    },
    {
      path: admin_path + "/unit/:id",
      name: "t.a.unit_show",
      meta: {
        title: "Unit",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "unit" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/unit/ShowUnit.vue"),
    },
    {
      path: admin_path + "/unit/:id/edit",
      name: "t.a.unit_edit",
      meta: {
        title: "Unit",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "unit" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/unit/EditUnit.vue"),
    },

    {
      path: admin_path + "/product-type",
      name: "t.a.producttype",
      meta: {
        title: "Product Type",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Product Type" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/product-type/Index.vue"),
    },
    {
      path: admin_path + "/product-type/create",
      name: "t.a.producttype_create",
      meta: {
        title: "Product Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "product type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/product-type/AddProductType.vue"),
    },
    {
      path: admin_path + "/product-type/:id",
      name: "t.a.producttype_show",
      meta: {
        title: "Product Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "product type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/product-type/ShowProductType.vue"),
    },
    {
      path: admin_path + "/product-type/:id/edit",
      name: "t.a.producttype_edit",
      meta: {
        title: "Product Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "product type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/product-type/EditProductType.vue"),
    },

    {
      path: admin_path + "/salepage-type",
      name: "t.a.salepagetype",
      meta: {
        title: "SalePage Type",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Salepage Type" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/salepage-type/Index.vue"),
    },
    {
      path: admin_path + "/salepage-type/create",
      name: "t.a.salepagetype_create",
      meta: {
        title: "SalePage Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "salepage type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/salepage-type/AddSalePageType.vue"),
    },
    {
      path: admin_path + "/salepage-type/:id",
      name: "t.a.salepagetype_show",
      meta: {
        title: "SalePage Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "salepage type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/salepage-type/ShowSalePageType.vue"),
    },
    {
      path: admin_path + "/salepage-type/:id/edit",
      name: "t.a.salepagetype_edit",
      meta: {
        title: "SalePage Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "salepage type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/salepage-type/EditSalePageType.vue"),
    },

    {
      path: admin_path + "/label-type",
      name: "t.a.labeltype",
      meta: {
        title: "Label Type",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Label Type" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/label-type/Index.vue"),
    },
    {
      path: admin_path + "/label-type/create",
      name: "t.a.labeltype_create",
      meta: {
        title: "Label Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "label type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/label-type/AddLabelType.vue"),
    },
    {
      path: admin_path + "/label-type/:id",
      name: "t.a.labeltype_show",
      meta: {
        title: "Label Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "label type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/label-type/ShowLabelType.vue"),
    },
    {
      path: admin_path + "/label-type/:id/edit",
      name: "t.a.labeltype_edit",
      meta: {
        title: "Label Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "label type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/label-type/EditLabelType.vue"),
    },

    {
      path: admin_path + "/integration-group",
      name: "t.a.integrationgroup",
      meta: {
        title: "Integration Group",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Integration Group" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/integration-group/Index.vue"),
    },
    {
      path: admin_path + "integration-group/create",
      name: "t.a.integrationgroup_create",
      meta: {
        title: "Integration Group",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "integration group" }],
        suffix: title_suffix,
      },
      component: () =>
        import(
          "@/components/web/admin/integration-group/AddIntegrationGroup.vue"
        ),
    },
    {
      path: admin_path + "/integration-group/:id",
      name: "t.a.integrationgroup_show",
      meta: {
        title: "Integration Group",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "integration group" }],
        suffix: title_suffix,
      },
      component: () =>
        import(
          "@/components/web/admin/integration-group/ShowIntegrationGroup.vue"
        ),
    },
    {
      path: admin_path + "/integration-group/:id/edit",
      name: "t.a.integrationgroup_edit",
      meta: {
        title: "Integration Group",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "integration group" }],
        suffix: title_suffix,
      },
      component: () =>
        import(
          "@/components/web/admin/integration-group/EditIntegrationGroup.vue"
        ),
    },

    {
      path: admin_path + "/module",
      name: "t.a.module",
      meta: {
        title: "Module",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Module" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/module/Index.vue"),
    },
    {
      path: admin_path + "module/create",
      name: "t.a.module_create",
      meta: {
        title: "Module",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "module" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/module/AddModule.vue"),
    },
    {
      path: admin_path + "/module/:id",
      name: "t.a.module_show",
      meta: {
        title: "Module",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "module" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/module/ShowModule.vue"),
    },
    {
      path: admin_path + "/module/:id/edit",
      name: "t.a.module_edit",
      meta: {
        title: "Module",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "module" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/module/EditModule.vue"),
    },

    {
      path: admin_path + "/location-type",
      name: "t.a.locationtype",
      meta: {
        title: "Location Type",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Location Type" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/location-type/Index.vue"),
    },
    {
      path: admin_path + "locationtype/create",
      name: "t.a.locationtype_create",
      meta: {
        title: "Location Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "location type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/location-type/AddLocationType.vue"),
    },
    {
      path: admin_path + "/location-type/:id",
      name: "t.a.locationtype_show",
      meta: {
        title: "Location Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "location type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/location-type/ShowLocationType.vue"),
    },
    {
      path: admin_path + "/location-type/:id/edit",
      name: "t.a.locationtype_edit",
      meta: {
        title: "Location Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "location type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/location-type/EditLocationType.vue"),
    },

    {
      path: admin_path + "/font",
      name: "t.a.font",
      meta: {
        title: "Font",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Font" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/font/Index.vue"),
    },
    {
      path: admin_path + "font/create",
      name: "t.a.font_create",
      meta: {
        title: "Font",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "font" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/font/AddFont.vue"),
    },
    {
      path: admin_path + "/font/:id",
      name: "t.a.font_show",
      meta: {
        title: "Font",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "font" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/font/ShowFont.vue"),
    },
    {
      path: admin_path + "/font/:id/edit",
      name: "t.a.font_edit",
      meta: {
        title: "Font",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "font" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/font/EditFont.vue"),
    },

    {
      path: admin_path + "/vat",
      name: "t.a.vat",
      meta: {
        title: "Vat",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Vat" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/vat/Index.vue"),
    },
    {
      path: admin_path + "/vat/create",
      name: "t.a.vat_create",
      meta: {
        title: "Vat",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "vat" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/vat/AddVat.vue"),
    },
    {
      path: admin_path + "/vat/:id",
      name: "t.a.vat_show",
      meta: {
        title: "Vat",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "vat" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/vat/ShowVat.vue"),
    },
    {
      path: admin_path + "/vat/:id/edit",
      name: "t.a.vat_edit",
      meta: {
        title: "Vat",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "vat" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/vat/EditVat.vue"),
    },

    {
      path: admin_path + "/timezone",
      name: "t.a.timezone",
      meta: {
        title: "Timezone",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Timezone" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/timezone/Index.vue"),
    },
    {
      path: admin_path + "/timezone/create",
      name: "t.a.timezone_create",
      meta: {
        title: "Timezone",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "timezone" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/timezone/AddTimeZone.vue"),
    },
    {
      path: admin_path + "/timezone/:id",
      name: "t.a.timezone_show",
      meta: {
        title: "Timezone",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "timezone" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/timezone/ShowTimeZone.vue"),
    },
    {
      path: admin_path + "/timezone/:id/edit",
      name: "t.a.timezone_edit",
      meta: {
        title: "Time Zone",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "time zone" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/timezone/EditTimeZone.vue"),
    },

    {
      path: admin_path + "/building-type",
      name: "t.a.building-type",
      meta: {
        title: "Building Type",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Building Type" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/building-type/Index.vue"),
    },
    {
      path: admin_path + "/building-type/create",
      name: "t.a.building-type-create",
      meta: {
        title: "Building Type",
        icon: "",
        breadcrumb: [
          { name: "resource" },
          { name: "building type", link: admin_path + "/building-type" },
          { name: "create building type" },
        ],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/building-type/AddBuildingType.vue"),
    },
    {
      path: admin_path + "/building-type/:id/edit",
      name: "t.a.building-type-edit",
      meta: {
        title: "Building Type",
        icon: "",
        breadcrumb: [
          { name: "resource" },
          { name: "building type", link: admin_path + "/building-type" },
          { name: "edit building type" },
        ],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/building-type/EditBuildingType.vue"),
    },

    {
      path: admin_path + "/building-type/:id",
      name: "t.a.building-type-show",
      meta: {
        title: "Building Type",
        icon: "",
        breadcrumb: [
          { name: "resource" },
          { name: "building type", link: admin_path + "/building-type" },
          { name: "show building type" },
        ],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/building-type/ShowBuildingType.vue"),
    },

    {
      path: admin_path + "/customer-group",
      name: "t.a.customer-group",
      meta: {
        title: "Customer Group",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Customer group" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/customer-group/Index.vue"),
    },
    {
      path: admin_path + "/customer-group/create",
      name: "t.a.customer-group-create",
      meta: {
        title: "Customer Group",
        icon: "",
        breadcrumb: [
          { name: "resource" },
          { name: "customer group", link: admin_path + "/customer-group" },
          { name: "create customer group" },
        ],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/customer-group/AddCustomerGroup.vue"),
    },
    {
      path: admin_path + "/customer-group/:id/edit",
      name: "t.a.customer-group-edit",
      meta: {
        title: "Customer Group",
        icon: "",
        breadcrumb: [
          { name: "resource" },
          { name: "customer group", link: admin_path + "/customer-group" },
          { name: "edit customer group" },
        ],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/customer-group/EditCustomerGroup.vue"),
    },
    {
      path: admin_path + "/customer-group/:id/show",
      name: "t.a.customer-group-show",
      meta: {
        title: "Customer Group",
        icon: "",
        breadcrumb: [
          { name: "resource" },
          { name: "customer group", link: admin_path + "/customer-group" },
          { name: "show customer group" },
        ],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/customer-group/ShowCustomerGroup.vue"),
    },

    {
      path: admin_path + "/currency",
      name: "t.a.currency",
      meta: {
        title: "Currency",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Currency" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/currency/Index.vue"),
    },
    {
      path: admin_path + "/currency/create",
      name: "t.a.currency_create",
      meta: {
        title: "Currency",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "currency" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/currency/AddCurrency.vue"),
    },
    {
      path: admin_path + "/currency/:id",
      name: "t.a.currency_show",
      meta: {
        title: "Currency",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "currency" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/currency/ShowCurrency.vue"),
    },
    {
      path: admin_path + "/currency/:id/edit",
      name: "t.a.currency_edit",
      meta: {
        title: "Currency",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "currency" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/currency/EditCurrency.vue"),
    },

    {
      path: admin_path + "/integration-type",
      name: "t.a.integrationtype",
      meta: {
        title: "Integration Type",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Integration Type" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/integration-type/Index.vue"),
    },
    {
      path: admin_path + "/integration-type/create",
      name: "t.a.integrationtype_create",
      meta: {
        title: "Integration Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "integration type" }],
        suffix: title_suffix,
      },
      component: () =>
        import(
          "@/components/web/admin/integration-type/AddIntegrationType.vue"
        ),
    },
    {
      path: admin_path + "/integration-type/:id",
      name: "t.a.integrationtype_show",
      meta: {
        title: "Integration Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "integration type" }],
        suffix: title_suffix,
      },
      component: () =>
        import(
          "@/components/web/admin/integration-type/ShowIntegrationType.vue"
        ),
    },
    {
      path: admin_path + "/integration-type/:id/edit",
      name: "t.a.integrationtype_edit",
      meta: {
        title: "Integration Type",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "integration type" }],
        suffix: title_suffix,
      },
      component: () =>
        import(
          "@/components/web/admin/integration-type/EditIntegrationType.vue"
        ),
    },

    {
      path: admin_path + "/delivery",
      name: "t.a.delivery",
      meta: {
        title: "Delivery",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Delivery" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/delivery/Index.vue"),
    },
    {
      path: admin_path + "/delivery/create",
      name: "t.a.delivery_create",
      meta: {
        title: "Delivery",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "delivery" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/delivery/AddDelivery.vue"),
    },
    {
      path: admin_path + "/delivery/:id",
      name: "t.a.delivery_show",
      meta: {
        title: "Delivery",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "delivery" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/delivery/ShowDelivery.vue"),
    },
    {
      path: admin_path + "/delivery/:id/edit",
      name: "t.a.delivery_edit",
      meta: {
        title: "Delivery",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "delivery" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/delivery/EditDelivery.vue"),
    },

    {
      path: admin_path + "/label",
      name: "t.a.label",
      meta: {
        title: "Label",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Label" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/label/Index.vue"),
    },
    {
      path: admin_path + "/label/create",
      name: "t.a.label_create",
      meta: {
        title: "Label",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "label" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/label/AddLabel.vue"),
    },
    {
      path: admin_path + "/label/:id",
      name: "t.a.label_show",
      meta: {
        title: "Label",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "label" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/label/ShowLabel.vue"),
    },
    {
      path: admin_path + "/label/:id/edit",
      name: "t.a.label_edit",
      meta: {
        title: "Label",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "label" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/label/EditLabel.vue"),
    },

    {
      path: admin_path + "/receipt",
      name: "t.a.receipt",
      meta: {
        title: "Receipt",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Receipt" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/receipt/Index.vue"),
    },
    {
      path: admin_path + "/receipt/create",
      name: "t.a.receipt_create",
      meta: {
        title: "Receipt",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "receipt" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/receipt/AddReceipt.vue"),
    },
    {
      path: admin_path + "/receipt/:id",
      name: "t.a.receipt_show",
      meta: {
        title: "Receipt",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "receipt" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/receipt/ShowReceipt.vue"),
    },
    {
      path: admin_path + "/receipt/:id/edit",
      name: "t.a.receipt_edit",
      meta: {
        title: "Receipt",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "receipt" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/receipt/EditReceipt.vue"),
    },

    {
      path: admin_path + "/taxInvoice",
      name: "t.a.tax_invoice",
      meta: {
        title: "Tax Invoice",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Tax Invoice" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/tax-invoice/Index.vue"),
    },
    {
      path: admin_path + "/taxInvoice/create",
      name: "t.a.tax_invoice_create",
      meta: {
        title: "Tax Invoice",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "taxInvoice" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/tax-invoice/AddTaxInvoice.vue"),
    },
    {
      path: admin_path + "/taxInvoice/:id",
      name: "t.a.tax_invoice_show",
      meta: {
        title: "Tax Invoice",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "taxInvoice" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/tax-invoice/ShowTaxInvoice.vue"),
    },
    {
      path: admin_path + "/taxInvoice/:id/edit",
      name: "t.a.tax_invoice_edit",
      meta: {
        title: "Tax Invoice",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "taxInvoice" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/tax-invoice/EditTaxInvoice.vue"),
    },

    {
      path: admin_path + "/language",
      name: "t.a.language",
      meta: {
        title: "Language",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "Language" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/language/Index.vue"),
    },
    {
      path: admin_path + "/language/create",
      name: "t.a.language_create",
      meta: {
        title: "Language",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "language" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/language/AddLanguage.vue"),
    },
    {
      path: admin_path + "/language/:id",
      name: "t.a.language_show",
      meta: {
        title: "Language",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "language" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/language/ShowLanguage.vue"),
    },
    {
      path: admin_path + "/language/:id/edit",
      name: "t.a.language_edit",
      meta: {
        title: "Language",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "language" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/language/EditLanguage.vue"),
    },

    {
      path: admin_path + "/user",
      name: "t.a.user",
      meta: {
        title: "User",
        icon: "",
        breadcrumb: [{ name: "Resource" }, { name: "User" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/user/Index.vue"),
    },
    {
      path: admin_path + "/user/create",
      name: "t.a.user_create",
      meta: {
        title: "User",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "user" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/user/AddUser.vue"),
    },
    {
      path: admin_path + "/user/:id",
      name: "t.a.user_show",
      meta: {
        title: "User",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "user" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/user/ShowUser.vue"),
    },
    {
      path: admin_path + "/user/:id/edit",
      name: "t.a.user_edit",
      meta: {
        title: "User",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "user" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/user/EditUser.vue"),
    },
    {
      path: admin_path + "/white-label",
      name: "t.a.white_label",
      meta: {
        title: "White Label",
        icon: "",
        breadcrumb: [{ name: "Setting" }, { name: "White Label" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/white-label/Index.vue"),
    },
    {
      path: admin_path + "/leads",
      name: "t.a.leads",
      meta: {
        title: "Leads",
        icon: "",
        breadcrumb: [{ name: "Customers" }, { name: "Leads" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/leads/Index.vue"),
    },
    {
      path: admin_path + "/leads/:id",
      name: "t.a.leads.detail",
      meta: {
        title: "Leads Detail",
        icon: "",
        breadcrumb: [
          { name: "Customers" }, 
          { name: "Leads", link: admin_path + "/leads" },
          { name: 'Leads Detail' },
        ],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/leads/Detail.vue"),
    },
    {
      path: admin_path + "/store",
      name: "t.a.store",
      meta: {
        title: "Stores",
        icon: "",
        breadcrumb: [{ name: "customers" }, { name: "stores" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/store/Index.vue"),
    },
    {
      path: admin_path + "/store/:id",
      name: "t.a.store.view",
      meta: {
          title: 'Store',
          icon: '',
          breadcrumb: [
              { name: 'customer' },
              { name: 'store' , link: admin_path + "/store"},
              { name: 'store details' },
          ],
          suffix: title_suffix
      },
      component: () => import ('@/components/web/admin/store/Detail.vue'),
    },
    {
      path: admin_path + "/customer",
      name: "t.a.customer",
      meta: {
        title: "Customer",
        icon: "",
        breadcrumb: 
        [{ name: "customers" }, { name: "customers" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/customer/Index.vue"),
    },
    {
      path: admin_path + "/customer/clientfollowup",
      name: "t.a.customer.clientfollowup",
      meta: {
        title: "Client Follow Up",
        icon: "",
        breadcrumb: 
        [{ name: "customers" }, { name: "Client Follow Up" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/customer/:id",
      name: "t.a.customer_show",
      meta: {
        title: "Customer Detail",
        icon: "",
        breadcrumb: [
          { name: 'customers'},
          { name: 'customers' , link: admin_path + "/customer"},
          { name: "customer detail" }
        ],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/customer/ShowCustomer.vue"),
    },
    {
      path: admin_path + "/marketing/coupons",
      name: "t.a.coupons",
      meta: {
        title: "Coupons",
        icon: "",
        breadcrumb: [{ name: "marketing" }, { name: "Coupons" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/coupon/Index.vue"),
    },
    {
      path: admin_path + "/marketing/promotions",
      name: "t.a.promations",
      meta: {
        title: "Promotions",
        icon: "",
        breadcrumb: [{ name: "marketing" }, { name: "Promotions" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/promotion/Index.vue"),
    },
    {
      path: admin_path + "/marketing/monthly-generation",
      name: "t.a.monthly-generation",
      meta: {
        title: "Monthly Generation",
        icon: "",
        breadcrumb: [{ name: "marketing" }, { name: "Monthly Generation" }],
        suffix: title_suffix,
      },
      component: () =>
        import("@/components/web/admin/monthly-generation/Index.vue"),
    },
    {
      path: admin_path + "/marketing/clientfollowup",
      name: "t.a.marketing.clientfollowup",
      meta: {
        title: "Client Follow Up",
        icon: "",
        breadcrumb: [{ name: "marketing" }, { name: "Client Follow Up" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/utilities/adminactivitylog",
      name: "t.a.adminactivitylog",
      meta: {
        title: "Admin Activity Log",
        icon: "",
        breadcrumb: [{ name: "Utilities" }, { name: "Admin Activity Log" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/utilities/selleractivitylog",
      name: "t.a.selleractivitylog",
      meta: {
        title: "Seller Activity Log",
        icon: "",
        breadcrumb: [{ name: "Utilities" }, { name: "Seller Activity Log" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/utilities/notificationlog",
      name: "t.a.notificationlog",
      meta: {
        title: "Notification Log",
        icon: "",
        breadcrumb: [{ name: "Utilities" }, { name: "Notification Log" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/utilities/adminlog",
      name: "t.a.adminlog",
      meta: {
        title: "Admin Log",
        icon: "",
        breadcrumb: [{ name: "Utilities" }, { name: "Admin Log" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/utilities/attemptslog",
      name: "t.a.attemptslog",
      meta: {
        title: "Attempts Log",
        icon: "",
        breadcrumb: [{ name: "Utilities" }, { name: "Attempts Log" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/utilities/import",
      name: "t.a.import",
      meta: {
        title: "import",
        icon: "",
        breadcrumb: [{ name: "Utilities" }, { name: "Import" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/import/Index.vue"),
    },
    // ⛔ ปิดฟีเจอร์ Import XCOM — 28 ก.ย. 2026 · ถอด route `<admin>/utilities/import/xcom` ออก
    // เหตุผล: ฟีเจอร์เลิกใช้แล้ว — การนำเข้าครั้งล่าสุดของทั้งระบบคือ 27 ก.ย. 2023
    // ฝั่งหลังบ้านถอด route v1 `/importXcom` + v2 `/v2/import/xcom` และปิดคิวใน goqueue คู่กันแล้ว
    // component src/components/web/admin/import/xcom/ ยังอยู่ในที่เดิม แต่ไม่มีใครอ้างถึงแล้ว
    {
      path: admin_path + "/utilities/export/nicecall",
      name: "t.a.export.nicecall",
      meta: {
        title: "Export",
        icon: "",
        breadcrumb: [
          { name: "Utilities" }, 
          { name: "Export", link: admin_path + "/utilities/export" },
          { name: "Export NiceCall" }
        ],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/export/nicecall/Index.vue"),
    },
    {
      path: admin_path + "/utilities/export",
      name: "t.a.export",
      meta: {
        title: "export",
        icon: "",
        breadcrumb: [{ name: "Utilities" }, { name: "Export" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/export/Index.vue"),
    },
    {
      path: admin_path + "/report/salereport",
      name: "t.a.salereport",
      meta: {
        title: "Sale Report",
        icon: "",
        breadcrumb: [{ name: "Report" }, { name: "Sale Report" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/report/moduleusagereport",
      name: "t.a.moduleusagereport",
      meta: {
        title: "Module Usage Report",
        icon: "",
        breadcrumb: [{ name: "Report" }, { name: "Module Usage Report" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/report/planreport",
      name: "t.a.planreport",
      meta: {
        title: "Plan Report",
        icon: "",
        breadcrumb: [{ name: "Report" }, { name: "Plan Report" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/report/couponusagereport",
      name: "t.a.couponusagereport",
      meta: {
        title: "Coupon Usage Report",
        icon: "",
        breadcrumb: [{ name: "Report" }, { name: "Coupon Usage Report" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/report/promotionusagereport",
      name: "t.a.promotionusagereport",
      meta: {
        title: "Promotion Usage Report",
        icon: "",
        breadcrumb: [{ name: "Report" }, { name: "Promotion Usage Report" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/exportreport",
      name: "t.a.exportreport",
      meta: {
        title: "Export Report",
        icon: "",
        breadcrumb: [{ name: "Report" }, { name: "Export Report" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/report/ExportReportIndex.vue"),
    },
    {
      path: admin_path + "/setting/genaralsettings",
      name: "t.a.genaralsettings",
      meta: {
        title: "Genaral Settings",
        icon: "",
        breadcrumb: [{ name: "Setting" }, { name: "Genaral Settings" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/setting/plans",
      name: "t.a.plans",
      meta: {
        title: "Plans",
        icon: "",
        breadcrumb: [{ name: "Setting" }, { name: "Plans" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/setting/staff",
      name: "t.a.staff",
      meta: {
        title: "Staff",
        icon: "",
        breadcrumb: [{ name: "Setting" }, { name: "Staff" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/setting/role",
      name: "t.a.role",
      meta: {
        title: "Role",
        icon: "",
        breadcrumb: [{ name: "Setting" }, { name: "Role" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/setting/managelanguage",
      name: "t.a.managelanguage",
      meta: {
        title: "Manage Language",
        icon: "",
        breadcrumb: [{ name: "Setting" }, { name: "Manage Language" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/setting/currencies",
      name: "t.a.currencies",
      meta: {
        title: "Currencies",
        icon: "",
        breadcrumb: [{ name: "Setting" }, { name: "Currencies" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/setting/tag-management",
      name: "t.a.tag-management",
      meta: {
        title: "Tag Management",
        icon: "",
        breadcrumb: [
          { name: "Setting" }, 
          { name: "Tag Management" }
        ],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/tag-management/Index.vue"),
    },
    {
      path: admin_path + "/setting/saletaxes",
      name: "t.a.saletaxes",
      meta: {
        title: "Sale Taxes",
        icon: "",
        breadcrumb: [{ name: "Setting" }, { name: "Sale Taxes" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/setting/notificationtemplates",
      name: "t.a.notificationtemplates",
      meta: {
        title: "Notification Templates",
        icon: "",
        breadcrumb: [{ name: "Setting" }, { name: "Notification Templates" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/bank/Index.vue"),
    },
    {
      path: admin_path + "/domain",
      name: "t.a.domain",
      meta: {
        title: "Domain Name",
        icon: "",
        breadcrumb: [{ name: "Domain" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/domain/Index.vue"),
    },
    {
      path: admin_path + "/domain/:id",
      name: "t.a.domain.detail",
      meta: {
        title: "Domain Detail",
        icon: "",
        breadcrumb: [{ name: "resource" }, { name: "detail" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/domain/Detail.vue"),
    },
    {
      path: admin_path + "/announcement",
      name: "t.a.announcement",
      meta: {
        title: "Announcement",
        icon: "",
        breadcrumb: [{ name: "Utilities" }, { name: "Announcement" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/announcement/Index.vue"),
    },
    {
      path: admin_path + "/announcement/create",
      name: "t.a.announcement_create",
      meta: {
        title: "announcement",
        icon: "",
        breadcrumb: [{ name: "Utilities" }, { name: "Announcement" }, { name: "Create" }, ],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/announcement/AddAnnouncement.vue"),
    },
    {
      path: admin_path + "/announcement/:id/edit",
      name: "t.a.announcement_edit",
      meta: {
        title: "Announcement",
        icon: "",
        breadcrumb: [{ name: "Utilities" }, { name: "Announcement" }, { name: "Edit" }, ],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/announcement/EditAnnouncement.vue"),
    },
    {
      path: admin_path + "/announcement/:id",
      name: "t.a.announcement_show",
      meta: {
        title: "Announcement",
        icon: "",
        breadcrumb: [{ name: "Utilities" }, { name: "Announcement" }, { name: "Show" }, ],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/announcement/ShowAnnouncement.vue"),
    },
    {
      path: admin_path + "/utilities/import",
      name: "t.a.import",
      meta: {
        title: "import",
        icon: "",
        breadcrumb: [{ name: "Utilities" }, { name: "Import" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/import/Index.vue"),
    },
    // ⛔ ปิดฟีเจอร์ Import XCOM — 28 ก.ย. 2026 · ถอด route `<admin>/utilities/import/xcom` ออก
    // (บล็อกนี้ component ถูกคอมเมนต์ทิ้งไว้ก่อนแล้ว จึงเป็นเส้นทางที่เปิดหน้าเปล่าอยู่)
    {
      path: admin_path + "/utilities/import/update-buyer",
      name: "t.a.import.update_buyer",
      meta: {
        title: "Import",
        icon: "",
        breadcrumb: [
          { name: 'Utilities'},
          { name: 'Import', link: admin_path + "/utilities/import" },
          { name: 'Update Buyer' }
        ],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/import/update-buyer/update-buyer.vue"),
    },
    {
      path: admin_path + "/utilities/import/manual-buyer",
      name: "t.a.import.manual_buyer",
      meta: {
        title: "Import",
        icon: "",
        breadcrumb: [
          { name: 'Utilities'},
          { name: 'Import', link: admin_path + "/utilities/import" },
          { name: 'Manual Buyer' }
        ],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/import/manual-buyer/manual-buyer.vue"),
    },
    {
      path: admin_path + "/tools/emailblacklist",
      name: "t.a.emailblacklist",
      meta: {
        title: "Email Blacklist",
        icon: "",
        breadcrumb: [{ name: "Tools" }, { name: "Email Blacklist" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/emailblacklist/Index.vue"),
    },
    {
      path: admin_path + "/tools/emailwhitelist",
      name: "t.a.emailwhitelist",
      meta: {
        title: "Email Whitelist",
        icon: "",
        breadcrumb: [{ name: "Tools" }, { name: "Email Whitelist" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/emailwhitelist/Index.vue"),
    },
    {
      path: admin_path + "/tools/check-user",
      name: "t.a.check_user",
      meta: {
        title: "Check User",
        icon: "",
        breadcrumb: [{ name: "Tools" }, { name: "Check User" }],
        suffix: title_suffix,
      },
      component: () => import("@/components/web/admin/check-user/Index.vue"),
    },
    {
      path: "/:catchAll(.*)",
      name: "Not Found",
      component: () => import("@/components/web/admin/error-page/404.vue"),
      meta: {
        title: "Not found",
        icon: "",
        breadcrumb: [{ name: "Not Found" }],
        suffix: title_suffix,
      },
    },
  ],
});

router.beforeEach((to, from, next) => {
  const publicPages = ["/login"];
  const ownerToken = Cookies.get("ownerToken");
  const authRequired = publicPages.includes(to.path);

  if (!authRequired && !ownerToken) {
    window.location.href = process.env.OWNER_URL + "/login";
    next();
  } else if (authRequired && ownerToken) {
    window.location.href = process.env.OWNER_URL;
    next();
  } else {
    next();
  }
});

axios.interceptors.request.use((request) => {
  return request;
});

axios.interceptors.response.use(
  (response) => {
    if (response.status === 201) {
    }
    return response;
  },
  (error) => {
    if (error.response != undefined && error.response.status == 401) {
      CentralAuth.logout();
      window.location.href = process.env.OWNER_URL + "/login";
    }
    return Promise.reject(error);
  }
);

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js